import { QueryClient } from '@tanstack/react-query';
import { ApiError } from '@/api/client';

/** TanStack Query default sozlamalari — offline-friendly (§14.3 kesh strategiyalariga mos) */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      refetchOnWindowFocus: false,
      retry: (failureCount, error) => {
        if (error instanceof ApiError && ['FORBIDDEN', 'NOT_FOUND', 'UNAUTHORIZED'].includes(error.code)) {
          return false;
        }
        return failureCount < 2;
      },
    },
    mutations: {
      retry: false,
    },
  },
});
